import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { LucideIcon } from 'components/LucideIcon'
import { Box } from 'designSystem/components/Box'
import {
  NavbarButtonContainer,
  StyledDropdownMenuContent,
  StyledDropdownMenuTrigger,
} from 'features/navbar'
import React from 'react'
import styled from 'styled-components'

import {
  DROPDOWN_CONTENT_STYLE,
  NotificationsDropdownBase,
} from './NotificationsDropdownBase'
import { NotificationsDropdownContent } from './NotificationsDropdownContent'

const NotificationBadge = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  background-color: ${({ theme }) =>
    theme.forecast.danger ?? theme.common.alert.error};
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.625rem;
  font-weight: 600;
  border: 2px solid ${({ theme }) => theme.forecast.background2};
`

export const NotificationsDropdownTopBar: React.FC = () => (
  <NotificationsDropdownBase
    renderTrigger={({
      isOpen,
      setIsOpen,
      arePlatformNotificationsEnabled,
      unreadCount,
    }) => (
      <StyledDropdownMenuTrigger asChild>
        <Box display='inlineFlex' style={{ position: 'relative' }}>
          <NavbarButtonContainer
            $isSelected={isOpen}
            tabIndex={0}
            role='button'
            aria-label='Open notifications'
            aria-expanded={isOpen}
            onClick={() => setIsOpen((o) => !o)}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                setIsOpen((o) => !o)
              }
            }}>
            <LucideIcon name='Bell' size={18} />
          </NavbarButtonContainer>
          {arePlatformNotificationsEnabled && unreadCount > 0 && (
            <NotificationBadge>{unreadCount}</NotificationBadge>
          )}
        </Box>
      </StyledDropdownMenuTrigger>
    )}
    renderContent={(contentProps) => (
      <DropdownMenu.Portal>
        <StyledDropdownMenuContent
          sideOffset={12}
          align='end'
          style={DROPDOWN_CONTENT_STYLE}>
          <NotificationsDropdownContent {...contentProps} />
        </StyledDropdownMenuContent>
      </DropdownMenu.Portal>
    )}
  />
)
